<script>
export default {
  name: 'MemberUnselectedItem',
  props: {
    index: { // index of current item
      type: Number
    },
    source: { // here is: {uid: 'unique_1', text: 'abc'}
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<template>
  <div class="member-unselected-item-content member-unselected-item-content-nexus">
    <el-checkbox :label="source" :checked="source.checked">
      <div class="available_depa_content">
        <div class="available_depa_left_icon2">
          <img src="@/assets/device.png"/>
        </div>
        <div>
          <div class="available_frame_tobeselected_name">
            {{ source.name }}
          </div>
          <div class="available_frame_tobeselected_depa">
            {{ source.deptName }}
          </div>
        </div>
      </div>
    </el-checkbox>
  </div>
</template>

<style scoped>
.member-unselected-item-content-nexus .el-checkbox{
  display: contents;
}
.available_depa_content{
  width: 100%;
  display: flex;
}
.member-unselected-item-content {
  display: flex;
  height: 56px;
  align-items: center;
  justify-content: start;
  padding: 0 20px;
  box-sizing: border-box;
}

.member-unselected-item-content .available_depa_left_icon2 {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #cbe7ff;
  margin: 0 8px 0 0;
}

.member-unselected-item-content .available_depa_left_icon2 img {
  width: 18px;
  height: 18px;
}

.member-unselected-item-content .available_frame_tobeselected_name {
  font-size: 15px;
  color: #1a1a1a;
}

.member-unselected-item-content .available_frame_tobeselected_depa {
  font-size: 13px;
  max-width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: rgba(26, 26, 26, 0.6);
}
</style>